import axios from 'axios';
import React from 'react';

export const refreshNewToken = () =>
  axios({
    method: 'put',
    url: 'api/refresh-token',
    data: {}
  });
